import { render, staticRenderFns } from "./IconRequired.vue?vue&type=template&id=282fef7e&scoped=true"
import script from "./IconRequired.vue?vue&type=script&lang=ts"
export * from "./IconRequired.vue?vue&type=script&lang=ts"
import style0 from "./IconRequired.vue?vue&type=style&index=0&id=282fef7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282fef7e",
  null
  
)

export default component.exports